import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import state from './state'
import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
  reducer: (data) => {
    return {
      userInfo: data.userInfo,
      labelList: data.labelList,
      DispatchList: data.DispatchList,
      collectionsTopArray: data.collectionsTopArray,
      isLoggedIn:data.isLoggedIn
    }
  }
})

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  plugins: [vuexLocal.plugin]
})
